import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	selectedLabel: {
		id: 'jql-builder-basic-picker.async-select.selected-label',
		defaultMessage: 'Selected',
		description: 'Label for the selected options group',
	},
	loadingStart: {
		id: 'jql-builder-basic-picker.async-select.loading-start',
		defaultMessage: 'Loading more',
		description: 'Screen reader message when a call to load more values for a filter field begins.',
	},
	loadingEnd: {
		id: 'jql-builder-basic-picker.async-select.loading-end',
		defaultMessage: 'Finished loading',
		description:
			'Screen reader message to notify users that the call to load more values for a filter field has finished.',
	},
});

export default messages;
